import { render, staticRenderFns } from "./ShowActxchange.vue?vue&type=template&id=f8bbfe02&scoped=true&"
import script from "./ShowActxchange.vue?vue&type=script&lang=js&"
export * from "./ShowActxchange.vue?vue&type=script&lang=js&"
import style0 from "./ShowActxchange.vue?vue&type=style&index=0&id=f8bbfe02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bbfe02",
  null
  
)

export default component.exports